module.exports = {
	"id": "KH",
	"name": "Cambodia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.04069,
			"12": 0.008138,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.012207,
			"21": null,
			"22": 0.016276,
			"23": 0.052897,
			"24": 0.004069,
			"25": 0.024414,
			"26": 0.008138,
			"27": 0.016276,
			"28": 0.028483,
			"29": 0.052897,
			"30": 0.024414,
			"31": 0.024414,
			"32": 0.008138,
			"33": 0.089518,
			"34": 0.012207,
			"35": 0.008138,
			"36": 0.016276,
			"37": 0.016276,
			"38": 0.024414,
			"39": 0.044759,
			"40": 0.036621,
			"41": 0.028483,
			"42": 0.036621,
			"43": 0.93587,
			"44": 0.044759,
			"45": 0.130208,
			"46": 0.056966,
			"47": 0.069173,
			"48": 0.105794,
			"49": 0.89518,
			"50": 0.280761,
			"51": 1.973465,
			"52": 0.980629,
			"53": 13.655564,
			"54": 3.90624,
			"55": 0.268554,
			"56": 0.073242,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012207,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.008138,
			"11": 0.016276,
			"12": 0.016276,
			"13": 0.008138,
			"14": 0.012207,
			"15": 0.008138,
			"16": 0.012207,
			"17": 0.004069,
			"18": 0.016276,
			"19": 0.012207,
			"20": 0.008138,
			"21": 0.012207,
			"22": 0.020345,
			"23": 0.016276,
			"24": null,
			"25": 0.020345,
			"26": 0.008138,
			"27": 0.028483,
			"28": 0.008138,
			"29": 0.052897,
			"30": 0.052897,
			"31": 0.032552,
			"32": 0.044759,
			"33": 0.166829,
			"34": 0.04069,
			"35": 0.077311,
			"36": 0.08138,
			"37": 0.085449,
			"38": 0.118001,
			"39": 0.105794,
			"40": 0.085449,
			"41": 0.134277,
			"42": 0.118001,
			"43": 0.398762,
			"44": 0.240071,
			"45": 0.166829,
			"46": 0.227864,
			"47": 1.13932,
			"48": 0.817869,
			"49": 4.549142,
			"50": 0.960284,
			"51": 0.008138,
			"52": null,
			"3.5": null,
			"3.6": 0.016276
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.004069,
			"35": 0.008138,
			"36": 0.012207,
			"37": 0.028483,
			"38": 0.179036,
			"39": 0.069173,
			"40": 0.415038,
			"41": 0.065104,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.020345
		},
		"safari": {
			"0": null,
			"4": 0.020345,
			"5": null,
			"6": 0.016276,
			"7": 0.020345,
			"8": 0.097656,
			"9": 0.126139,
			"10": 0.467935,
			"3.1": null,
			"3.2": null,
			"5.1": 0.012207,
			"6.1": 0.036621,
			"7.1": 0.008138,
			"9.1": 0.370279
		},
		"ios_saf": {
			"8": 0,
			"10": 16.8947423955,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.455293758222,
			"8.1-8.4": 0.841135926207,
			"9.0-9.2": 0.401275854704,
			"9.3": 6.12202906536
		},
		"android": {
			"3": 0,
			"4": 0.142252046512,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.017781505814,
			"4.1": 0.513123453488,
			"4.2-4.3": 1.28280863372,
			"4.4": 2.94156910465,
			"4.4.3-4.4.4": 2.96697125581
		},
		"ie": {
			"6": 0.0189956401028,
			"7": 0.00949782005141,
			"8": 0.479639912596,
			"9": 0.123471660668,
			"10": 0.189956401028,
			"11": 1.00676892545,
			"5.5": null
		},
		"op_mob": {
			"0": 0.139474950069,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00387430416858
		},
		"edge": {
			"12": 0.065104,
			"13": 0.187174,
			"14": 0.248209
		},
		"ie_mob": {
			"10": 0.0888814647887,
			"11": 0.361874535211
		},
		"bb": {
			"7": 0.0029655,
			"10": null
		},
		"samsung": {
			"0": 2.645226
		},
		"and_uc": {
			"0": 0.77103
		},
		"op_mini": {
			"0": 1.87912174576
		},
		"and_chr": {
			"0": 21.623614
		},
		"and_ff": {
			"0": 0.035586
		}
	},
	"total": 98.4172018599
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KH.json
 ** module id = 562
 ** module chunks = 0
 **/